"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenorReferenceDate = exports.ConvexityAdjustmentMethod = exports.ConvexityAdjustmentIntegrationMethod = exports.Outputs = exports.ExerciseStyle = exports.CallPut = exports.FxSwapCalculationMethod = exports.BuySell = exports.BusinessDayConvention = exports.AdjustInterest = exports.InterestCalculationConvention = exports.InflationMode = exports.IndexSpreadCompoundingMethod = exports.IndexCalculationMethod = exports.NotionalExchange = exports.ResetType = exports.InterestType = exports.IndexAverageMethod = exports.IndexObservationMethod = exports.AmortizationType = exports.AmortizationFrequency = exports.StubRule = exports.PaymentFrequency = exports.Direction = exports.PaymentRollConvention = exports.PriceSide = exports.DayCountBasisConvention = void 0;
var ipa_1 = require("../ipa");
Object.defineProperty(exports, "DayCountBasisConvention", { enumerable: true, get: function () { return ipa_1.DayCountBasisConvention; } });
Object.defineProperty(exports, "PriceSide", { enumerable: true, get: function () { return ipa_1.PriceSide; } });
var PaymentRollConvention;
(function (PaymentRollConvention) {
    PaymentRollConvention["Last"] = "Last";
    PaymentRollConvention["Same"] = "Same";
    PaymentRollConvention["Same1"] = "Same1";
    PaymentRollConvention["Last28"] = "Last28";
    PaymentRollConvention["Same28"] = "Same28";
})(PaymentRollConvention || (exports.PaymentRollConvention = PaymentRollConvention = {}));
var Direction;
(function (Direction) {
    Direction["Paid"] = "Paid";
    Direction["Received"] = "Received";
})(Direction || (exports.Direction = Direction = {}));
var PaymentFrequency;
(function (PaymentFrequency) {
    PaymentFrequency["Annual"] = "Annual";
    PaymentFrequency["SemiAnnual"] = "SemiAnnual";
    PaymentFrequency["Quarterly"] = "Quarterly";
    PaymentFrequency["Monthly"] = "Monthly";
    PaymentFrequency["BiMonthly"] = "BiMonthly";
    PaymentFrequency["Everyday"] = "Everyday";
    PaymentFrequency["EveryWorkingDay"] = "EveryWorkingDay";
    PaymentFrequency["Every7Days"] = "Every7Days";
    PaymentFrequency["Every14Days"] = "Every14Days";
    PaymentFrequency["Every28Days"] = "Every28Days";
    PaymentFrequency["Every30Days"] = "Every30Days";
    PaymentFrequency["Every91Days"] = "Every91Days";
    PaymentFrequency["Every182Days"] = "Every182Days";
    PaymentFrequency["Every364Days"] = "Every364Days";
    PaymentFrequency["Every365Days"] = "Every365Days";
    PaymentFrequency["Every90Days"] = "Every90Days";
    PaymentFrequency["Every92Days"] = "Every92Days";
    PaymentFrequency["Every93Days"] = "Every93Days";
    PaymentFrequency["Every180Days"] = "Every180Days";
    PaymentFrequency["Every183Days"] = "Every183Days";
    PaymentFrequency["Every184Days"] = "Every184Days";
    PaymentFrequency["Every4Months"] = "Every4Months";
    PaymentFrequency["R2"] = "R2";
    PaymentFrequency["R4"] = "R4";
    PaymentFrequency["Zero"] = "Zero";
    PaymentFrequency["Scheduled"] = "Scheduled";
})(PaymentFrequency || (exports.PaymentFrequency = PaymentFrequency = {}));
var StubRule;
(function (StubRule) {
    StubRule["Issue"] = "Issue";
    StubRule["Maturity"] = "Maturity";
    StubRule["ShortFirstProRata"] = "ShortFirstProRata";
    StubRule["ShortFirstFull"] = "ShortFirstFull";
    StubRule["LongFirstFull"] = "LongFirstFull";
    StubRule["ShortLastProRata"] = "ShortLastProRata";
})(StubRule || (exports.StubRule = StubRule = {}));
var AmortizationFrequency;
(function (AmortizationFrequency) {
    AmortizationFrequency["Once"] = "Once";
    AmortizationFrequency["EveryCoupon"] = "EveryCoupon";
    AmortizationFrequency["Every2ndCoupon"] = "Every2ndCoupon";
    AmortizationFrequency["Every3rdCoupon"] = "Every3rdCoupon";
    AmortizationFrequency["Every4thCoupon"] = "Every4thCoupon";
    AmortizationFrequency["Every12thCoupon"] = "Every12thCoupon ";
})(AmortizationFrequency || (exports.AmortizationFrequency = AmortizationFrequency = {}));
var AmortizationType;
(function (AmortizationType) {
    AmortizationType["None"] = "None";
    AmortizationType["Linear"] = "Linear";
    AmortizationType["Annuity"] = "Annuity";
    AmortizationType["Schedule"] = "Schedule ";
})(AmortizationType || (exports.AmortizationType = AmortizationType = {}));
var IndexObservationMethod;
(function (IndexObservationMethod) {
    IndexObservationMethod["Lookback"] = "Lookback";
    IndexObservationMethod["PeriodShift"] = "PeriodShift";
    IndexObservationMethod["Mixed"] = "Mixed";
})(IndexObservationMethod || (exports.IndexObservationMethod = IndexObservationMethod = {}));
var IndexAverageMethod;
(function (IndexAverageMethod) {
    IndexAverageMethod["CompoundedActual"] = "CompoundedActual";
    IndexAverageMethod["DailyCompoundedAverage"] = "DailyCompoundedAverage";
    IndexAverageMethod["CompoundedAverageRate"] = "CompoundedAverageRate";
    IndexAverageMethod["ArithmeticAverage"] = "ArithmeticAverage";
})(IndexAverageMethod || (exports.IndexAverageMethod = IndexAverageMethod = {}));
var InterestType;
(function (InterestType) {
    InterestType["Fixed"] = "Fixed";
    InterestType["Float"] = "Float";
    InterestType["Stepped"] = "Stepped";
})(InterestType || (exports.InterestType = InterestType = {}));
var ResetType;
(function (ResetType) {
    ResetType["InAdvance"] = "InAdvance";
    ResetType["InArrears"] = "InArrears";
})(ResetType || (exports.ResetType = ResetType = {}));
var NotionalExchange;
(function (NotionalExchange) {
    NotionalExchange["None"] = "None";
    NotionalExchange["Start"] = "Start";
    NotionalExchange["End"] = "End";
    NotionalExchange["Both"] = "Both";
    NotionalExchange["EndAdjustment"] = "EndAdjustment";
})(NotionalExchange || (exports.NotionalExchange = NotionalExchange = {}));
var IndexCalculationMethod;
(function (IndexCalculationMethod) {
    IndexCalculationMethod["Compounded"] = "Compounded";
    IndexCalculationMethod["Average"] = "Average";
    IndexCalculationMethod["Constant"] = "Constant";
    IndexCalculationMethod["AdjustedCompounded"] = "AdjustedCompounded";
    IndexCalculationMethod["MexicanCompounded"] = "MexicanCompounded";
})(IndexCalculationMethod || (exports.IndexCalculationMethod = IndexCalculationMethod = {}));
var IndexSpreadCompoundingMethod;
(function (IndexSpreadCompoundingMethod) {
    IndexSpreadCompoundingMethod["IsdaCompounding"] = "IsdaCompounding";
    IndexSpreadCompoundingMethod["NoCompounding"] = "NoCompounding";
    IndexSpreadCompoundingMethod["IsdaFlatCompounding"] = "IsdaFlatCompounding";
})(IndexSpreadCompoundingMethod || (exports.IndexSpreadCompoundingMethod = IndexSpreadCompoundingMethod = {}));
var InflationMode;
(function (InflationMode) {
    InflationMode["Unadjusted"] = "Unadjusted";
    InflationMode["Adjusted"] = "Adjusted";
    InflationMode["Default"] = "Default";
})(InflationMode || (exports.InflationMode = InflationMode = {}));
var InterestCalculationConvention;
(function (InterestCalculationConvention) {
    InterestCalculationConvention["None"] = "None";
    InterestCalculationConvention["MoneyMarket"] = "MoneyMarket";
    InterestCalculationConvention["BondBasis"] = "BondBasis";
})(InterestCalculationConvention || (exports.InterestCalculationConvention = InterestCalculationConvention = {}));
var AdjustInterest;
(function (AdjustInterest) {
    AdjustInterest["Unadjusted"] = "Unadjusted";
    AdjustInterest["Adjusted"] = "Adjusted";
})(AdjustInterest || (exports.AdjustInterest = AdjustInterest = {}));
var BusinessDayConvention;
(function (BusinessDayConvention) {
    BusinessDayConvention["PreviousBusinessDay"] = "PreviousBusinessDay";
    BusinessDayConvention["NextBusinessDay"] = "NextBusinessDay";
    BusinessDayConvention["ModifiedFollowing"] = "ModifiedFollowing";
    BusinessDayConvention["NoMoving"] = "NoMoving";
    BusinessDayConvention["EveryThirdWednesday"] = "EveryThirdWednesday";
    BusinessDayConvention["BBSWModifiedFollowing"] = "BBSWModifiedFollowing";
})(BusinessDayConvention || (exports.BusinessDayConvention = BusinessDayConvention = {}));
var BuySell;
(function (BuySell) {
    BuySell["Buy"] = "Buy";
    BuySell["Sell"] = "Sell";
})(BuySell || (exports.BuySell = BuySell = {}));
var FxSwapCalculationMethod;
(function (FxSwapCalculationMethod) {
    FxSwapCalculationMethod["FxSwap"] = "FxSwap";
    FxSwapCalculationMethod["DepositCcy1ImpliedFromFxSwap"] = "DepositCcy1ImpliedFromFxSwap";
    FxSwapCalculationMethod["DepositCcy2ImpliedFromFxSwap"] = "DepositCcy2ImpliedFromFxSwap";
    FxSwapCalculationMethod["FxSwapImpliedFromDeposit"] = "FxSwapImpliedFromDeposit";
})(FxSwapCalculationMethod || (exports.FxSwapCalculationMethod = FxSwapCalculationMethod = {}));
var CallPut;
(function (CallPut) {
    CallPut["Call"] = "Call";
    CallPut["Put"] = "Put";
})(CallPut || (exports.CallPut = CallPut = {}));
var ExerciseStyle;
(function (ExerciseStyle) {
    ExerciseStyle["Euro"] = "EURO";
    ExerciseStyle["Amer"] = "AMER";
    ExerciseStyle["Berm"] = "BERM ";
})(ExerciseStyle || (exports.ExerciseStyle = ExerciseStyle = {}));
var Outputs;
(function (Outputs) {
    Outputs["Headers"] = "Headers";
    Outputs["Statuses"] = "Statuses";
    Outputs["Data"] = "Data";
    Outputs["MarketData"] = "MarketData";
})(Outputs || (exports.Outputs = Outputs = {}));
var Type;
(function (Type) {
    Type["InvalidField"] = "InvalidField";
    Type["String"] = "String";
    Type["Float"] = "Float";
    Type["DateTime"] = "DateTime";
    Type["Integer"] = "Integer";
    Type["Object"] = "Object";
    Type["Date"] = "Date";
    Type["Bool"] = "Bool";
    Type["StringArray"] = "StringArray";
    Type["FloatArray"] = "FloatArray";
    Type["DateArray"] = "DateArray";
    Type["ObjectArray"] = "ObjectArray";
})(Type || (Type = {}));
var ConvexityAdjustmentIntegrationMethod;
(function (ConvexityAdjustmentIntegrationMethod) {
    ConvexityAdjustmentIntegrationMethod["RiemannSum"] = "RiemannSum";
    ConvexityAdjustmentIntegrationMethod["RungeKutta"] = "RungeKutta";
})(ConvexityAdjustmentIntegrationMethod || (exports.ConvexityAdjustmentIntegrationMethod = ConvexityAdjustmentIntegrationMethod = {}));
var ConvexityAdjustmentMethod;
(function (ConvexityAdjustmentMethod) {
    ConvexityAdjustmentMethod["None"] = "None";
    ConvexityAdjustmentMethod["BlackScholes"] = "BlackScholes";
    ConvexityAdjustmentMethod["Replication"] = "Replication";
    ConvexityAdjustmentMethod["LinearSwapModel"] = "LinearSwapModel";
})(ConvexityAdjustmentMethod || (exports.ConvexityAdjustmentMethod = ConvexityAdjustmentMethod = {}));
var TenorReferenceDate;
(function (TenorReferenceDate) {
    TenorReferenceDate["SpotDate"] = "SpotDate";
    TenorReferenceDate["ValuationDate"] = "ValuationDate";
})(TenorReferenceDate || (exports.TenorReferenceDate = TenorReferenceDate = {}));
